import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { companySettingsApi } from '../api/settings'

export function usePageTitle(title: string | null | undefined) {
  const { companyId } = useParams<{ companyId?: string }>()

  const { data: companyName } = useQuery({
    queryKey: ['company-name', companyId],
    queryFn: () => companySettingsApi.getGeneral(companyId!).then(r => r.data.name),
    enabled: !!companyId,
    staleTime: 15 * 60 * 1000,
  })

  useEffect(() => {
    if (!title) return
    document.title = companyName ? `${title} - ${companyName}` : title
  }, [title, companyName])
}
